<template>
  <a-modal v-model="modalVisible" title="选择显示屏" :width="900" :centered="true">
    <template slot="footer">
      <a-button @click="modalVisible=false">取消</a-button>
      <a-button type="primary" @click="confirm">确认</a-button>
    </template>
    <div class="select-modal-container">
      <a-form-model ref="queryForm" :model="queryParams" layout="inline">
        <a-form-model-item label="显示屏名称" prop="monitorname">
          <a-input v-model.trim="queryParams.monitorname" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="显示屏编号" prop="monitornum">
          <a-input v-model.trim="queryParams.monitornum" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="显示屏类型" prop="monitortype">
          <a-select v-model="queryParams.monitortype" style="width: 180px;">
            <a-select-option value="">请选择</a-select-option>
            <a-select-option v-for="(item, index) in monitortypes" :key="index" :value="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetQueryForm">重置</a-button>
          <a-button type="primary" style="margin-left: 10px;" @click="getTableData(true)">查询</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table :columns="tableColumns" :data-source="tableData" row-key="monitorid" :row-selection="{ type: selectType, selectedRowKeys: selectedRowKeys, onSelect: onSelectRow, onSelectAll: onSelectAllRows }" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 16px;" :pagination="false">
        <span slot="monitortype" slot-scope="text">
          <span class="text">{{monitortypesMap[text]||''}}</span>
        </span>
        <span slot="isonline" slot-scope="value">
          <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'在线':'离线'}}</a-tag>
        </span>
      </a-table>
      <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" @change="pageChange" style="margin-top: 20px; text-align: right;">
        <template slot="buildOptionText" slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
  </a-modal>
</template>
<script>
import pagination from '@/mixins/pagination'
import {
  getTerminaltypeListByCondition,
  getDeviceinfoListByCondition,
  deleteDeviceinfo,
  getMonitortypeListByCondition
} from 'A/ai.js'
import {getLiftDeviceinfoListByCondition, getLiftMonitorinfoListByCondition} from "A/ai";
export default {
  mixins: [pagination],
  props: {
    visible: {
      default: false
    },
    selectType: {
      default: 'checkbox'
    },
    defaultSelected: {
      default() {
        return []
      }
    },
    params: {
      default: null
    },
    formData:{
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      monitortypes: [],
      queryParams: {
        monitorname: '',
        monitornum: '',
        monitortype: '',
      },
      tableLoading: false,
      tableColumns: [
        {
          title: '显示屏名称',
          dataIndex: 'monitorname',
          key: 'monitorname',
          ellipsis: true,
        },
        {
          title: '显示屏编号',
          dataIndex: 'monitornum',
          key: 'monitornum',
          ellipsis: true,
        },
        {
          title: '显示屏型号',
          dataIndex: 'monitortype',
          key: 'monitortype',
          ellipsis: true,
          scopedSlots: { customRender: 'monitortype' }
        },
        {
          title: '在线状态',
          dataIndex: 'isonline',
          key: 'isonline',
          ellipsis: true,
          scopedSlots: { customRender: 'isonline' }
        },
      ],
      tableData: [],
      selectedRows: [],
      currentPage: 1,
      pagination: {
        total: 0,
        pageSize: 5,
      }
    }
  },
  computed: {
    selectedRowKeys() {
      let currentSelectKeys = this.selectedRows.map(item => item.monitorid);
      return currentSelectKeys;
    },
    monitortypesMap() {
      let result = {};
      this.monitortypes.forEach(item => {
        result[item.value] = item.text;
      })
      return result;
    }
  },
  watch: {
    visible(val) {
      if(val) {
        this.modalVisible = true;
        this.selectedRows = this.defaultSelected || [];
        this.init();
      }else {
        this.selectedRows = []
      }
    },
    modalVisible(val) {
      if(!val) {
        this.$emit('update:visible', false);
      }
    },
    params(val) {
      if(val) {
        // console.log(val)
        this.queryParams = {...this.queryParams, ...val};
      }
    },
  },
  created() {
    // this.init();
  },
  methods: {
    init() {
      if(this.params) {
        this.queryParams = {...this.queryParams, ...this.params};
      }
      this.modalVisible = this.visible;
      this.getMonitortypes();
    },
    getMonitortypes() {
      getMonitortypeListByCondition({}).then(res => {
        if(res && res.returncode == '0') {
          this.monitortypes = res.item.map(item => {
            return {
              value: item.monitortypeid,
              text: item.monitortypename,
            }
          });
        }
        this.getTableData();
      }).catch(err => {
        this.getTableData();
      })
    },
    resetQueryForm() {
      this.$refs.queryForm.resetFields();
    },
    getTableData(firstPage) {
      if(firstPage) {
        this.currentPage = 1;
      }
      let params = {
        ...this.queryParams,
        liftid: this.formData.liftid,
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize,
      };
      getLiftMonitorinfoListByCondition(params).then(res => {
        if(res && res.returncode == '0') {
          this.tableData = res.item.map(item => {
            item.monitorid = '' + item.monitorid;
            return item;
          });
          this.pagination.total = res.count;
        }
      })
    },
    onSelectRow(record, selected, selectedRows, nativeEvent) {
      if(selected) {
        if(this.selectType == 'radio') {
          this.selectedRows = [record]
        }else if(this.selectedRowKeys.indexOf(record.monitorid) < 0) {
          this.selectedRows.push(record);
        }
      }else {
        this.selectedRows = this.selectedRows.filter(item => item.monitorid!=record.monitorid)
      }
    },
    onSelectAllRows(selected, selectedRows, changeRows) {
      if(selected) {
        this.tableData.forEach(record => {
          if(this.selectedRowKeys.indexOf(record.monitorid) < 0) {
            this.selectedRows.push(record);
          }
        })
      }else {
        this.tableData.forEach(record => {
          this.selectedRows = this.selectedRows.filter(item => item.monitorid!=record.monitorid)
        })
      }
    },
    confirm() {
      console.log(this.selectedRows)
      this.$emit('get-monitor-selected-rows', this.selectedRows);
      this.modalVisible = false;
    }
  }
}
</script>